export default () => {
  const map = document.querySelector('.js-map');

  if (!map) {
    return;
  }

  // get coordinates from html data attribute
  let lat = 51.7826309;
  let lng = 4.6222924;

  if (map.dataset.lat) {
    lat = parseFloat(map.dataset.lat);
  }
  if (map.dataset.lng) {
    lng = parseFloat(map.dataset.lng);
  }

  // add google maps script
  const script = document.createElement('script');
  const apiKey = 'AIzaSyC_r5JX7jmpS1a0VBtMg-XKXbJ_VXdxfL8';
  script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${apiKey}&callback=mapsCallback`;
  document.body.appendChild(script);

  window.mapsCallback = () => {
    if (map) {
      displayMap(lat, lng);
    }
  };

  const displayMap = (lat, lng) => {

    // google maps styling
    const styles = [
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{lightness: 10}, {visibility: 'simplified'}],
      },
      {
        featureType: 'road',
        elementType: 'labels',
      },
    ];
    const coordinates = {
      lat: lat,
      lng: lng,
    };
    const options = {
      zoom: 17,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      scaleControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: styles,
    };
    const map = new window.google.maps.Map(
        document.getElementById('maps'),
        options,
    );

    let icon = {
      url: '/wp-content/themes/barthgroep/img/marker@2x.png',
      scaledSize: new google.maps.Size(84, 112), // scaled size
    };

    const redMarker = new window.google.maps.Marker({
      map: map,
      icon: icon,
      position: {
        lat: coordinates.lat,
        lng: coordinates.lng,
      },
    });

    return redMarker;
  };
}

// WEBPACK FOOTER //
// ./src/js/modules/Maps.js